import { getOSM } from '../OverworldAnimation.js';
import Item from './Item.js';
import { CANT_USE_ITEM, TOWN_MAP } from '../constants.js';
import { globalItemDataStore } from '../OverworldAnimation.js';

export default class KeyItem extends Item {
    constructor({ id }) {
        super({ id });
        const data = globalItemDataStore[id] ?? {};
        this.name = data.name ?? '';
        this.description = data.description ?? '';
        this.canBeHeld = false;
    }

    use() {
        switch (this.id) {
            case 'bicycle':
                if (getOSM().currentMap.canBike && !getOSM().player.surfing) {
                    getOSM().player.biking = !getOSM().player.biking;
                } else {
                    getOSM().stateQueue.push(CANT_USE_ITEM);
                }
                break;
            case 'lunchbox':
                getOSM().stateQueue.push(CANT_USE_ITEM);
                break;
            case 'town_map':
                getOSM().stateQueue.push(TOWN_MAP);
                break;
            default:
                break;
        }
    }

    isKeyItem() {
        return true;
    }
}
